// extracted by mini-css-extract-plugin
module.exports = {"root":"AnswerScale_root__2Rv6n","options":"AnswerScale_options__17r53","selected":"AnswerScale_selected__3QS9G"};